import { render, staticRenderFns } from "./connection.vue?vue&type=template&id=a493598a&scoped=true&"
import script from "./connection.vue?vue&type=script&lang=js&"
export * from "./connection.vue?vue&type=script&lang=js&"
import style0 from "./connection.vue?vue&type=style&index=0&id=a493598a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a493598a",
  null
  
)

export default component.exports